import { reactive } from 'vue'

export const sessionExpiryState = reactive({
  isVisible: false,
  title: 'Your login session is expired.',
  message: 'Your session has expired. Please log in again.',
  isHandling: false,
})

const clearCookie = cookieName => {
  const expirationDate = new Date()

  expirationDate.setFullYear(expirationDate.getFullYear() - 1)
  document.cookie = `${cookieName}=; expires=${expirationDate.toUTCString()}; path=/;`
}

export const clearStoredAuth = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('userData')
  localStorage.removeItem('sessionTimeout')
  clearCookie('userData')
  clearCookie('accessToken')
  window.dispatchEvent(new CustomEvent('session-auth-cleared'))
}

export const hasStoredAuth = () => {
  return !!(localStorage.getItem('token') && localStorage.getItem('userData'))
}

export const handleSessionExpired = ({
  title = 'Your login session is expired.',
  message = 'Your session has expired. Please log in again.',
} = {}) => {
  if (window.location.pathname === '/login') {
    clearStoredAuth()

    return
  }

  if (!hasStoredAuth()) {
    return
  }

  clearStoredAuth()

  if (sessionExpiryState.isHandling) {
    return
  }

  sessionExpiryState.title = title
  sessionExpiryState.message = message
  sessionExpiryState.isVisible = true
  sessionExpiryState.isHandling = true
}

export const redirectToLoginAfterSessionExpiry = () => {
  sessionExpiryState.isVisible = false
  sessionExpiryState.isHandling = false
  window.location.href = '/login'
}
